import React from "react";
import { FaBell, FaUser, FaCog, FaSignOutAlt, FaBars } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { ASSETS } from "../config/assets";
import ThemeSwitch from "./ThemeSwitch";

const Header = ({ onMenuToggle }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    // Handle logout logic here
    navigate("/login");
  };

  return (
    <header className="admin-header">
      <div className="admin-header-inner">
        <div className="logo">
          <button
            type="button"
            className="admin-menu-btn"
            onClick={onMenuToggle}
            aria-label="Open navigation menu"
          >
            <FaBars size={20} />
          </button>
          <span className="logo-text">{ASSETS.brandDomain}</span>
        </div>

        <nav className="admin-header-nav">
          <ThemeSwitch />
          <button className="nav-btn">
            <FaBell size={20} />
            <span className="notification-badge">3</span>
          </button>

          <button className="nav-btn">
            <FaUser className="me-2" />
            <span>Profile</span>
          </button>

          <button className="nav-btn">
            <FaCog className="me-2" />
            <span>Settings</span>
          </button>

          <button className="nav-btn" onClick={handleLogout}>
            <FaSignOutAlt className="me-2" />
            <span>Logout</span>
          </button>
        </nav>
      </div>
    </header>
  );
};

export default Header;
